import { getModel } from '../../model/registry'
import { useState } from 'react'
import ReactDOM from 'react-dom'
import styled from 'styled-components'
import { useSnapshot } from 'valtio'

import useScreenSize from '../../hooks/useScreenSize'
import useTranslation from '../../hooks/useTranslation'
import { useStore } from '../pageView/Page'
import { icon } from '../../styles/icons'
import Modal from '../modal/Modal'

import LineDocuments from './LineDocuments'
import { documentLine, showLineDocuments } from './documentLineState'

/*
 * A line's documents button: a paper clip and how many documents the line has
 * (deleted ones not counted). On desktop it points the side panel at the line;
 * on mobile, where there is no panel, it opens the line's documents full
 * screen.
 */

const Button = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.125rem;
  flex: 0 0 auto;
  background: none;
  border: none;
  border-radius: 0.375rem;
  padding: 0.25rem;
  color: ${({ theme, $active, $count }) => $active || $count ? theme.tab.navLinkColor : theme.font.label};
  opacity: ${({ $active, $count }) => $active || $count ? 1 : 0.5};
  font-size: var(--font-XS);
  cursor: pointer;

  svg { font-size: 1.125rem; }
  &:hover { opacity: 1; color: ${({ theme }) => theme.tab.navLinkColor}; }
`

const LineDocumentsButton = ({ lineDocuments, index }) => {
  const config = getModel('lineDocumentsData')[lineDocuments] ?? {}
  const linesArray = config.linesArray ?? 'lines'
  const [attachments] = useStore(s => s?.[linesArray]?.[index]?.attachments)
  const { isMobile } = useScreenSize()
  const { t } = useTranslation()
  const shown = useSnapshot(documentLine)
  const [open, setOpen] = useState(false)

  const count = Array.isArray(attachments) ? attachments.filter(a => !a.deletedAt).length : 0
  const active = !isMobile && shown.index === index

  const handleClick = (e) => {
    // A closed line opens when its row is clicked; the button is not that click.
    e.stopPropagation()
    if (isMobile) setOpen(true)
    else showLineDocuments(index)
  }

  return (
    <>
      <Button type="button" title={t('document.lines.title')} onClick={handleClick}
        $active={active} $count={count > 0} data-testid={`lineDocuments.${index + 1}`}>
        {icon.attachment}
        {count > 0 && <span>{count}</span>}
      </Button>
      {open && ReactDOM.createPortal(
        <Modal show={open} setShow={setOpen} mode='fullscreen' zIndex={1100}>
          <Modal.Header onClose={() => setOpen(false)}>
            <h4>{t('document.lines.title')}</h4>
          </Modal.Header>
          <Modal.Body>
            <LineDocuments lineDocuments={lineDocuments} index={index} />
          </Modal.Body>
        </Modal>,
        document.body
      )}
    </>
  )
}

export default LineDocumentsButton
